import React, { Component } from 'react';
import Modal from 'react-modal';
import { Redirect } from 'react-router-dom';
import ProcessManager from '../../../Common/Managers/ProcessManager.js';
import Empresa from './Empresa/Empresa.jsx';
import Cuenta from './Cuenta/Cuenta.jsx';
import Tarjeta from './Tarjeta/Tarjeta.jsx';
import SaldosResumenes from '../../SaldosResumenes/components/Container.jsx';
//import IngresoAjustes from '../../IngresoAjustes/components/Container.jsx';
import IngresoCobranzas from '../../IngresoCobranzas/components/Container.jsx';

import MenuDesplegable from './MenuDesplegable/MenuDesplegable.jsx';
import { updateLimites } from '../actions/PanelSeleccionActions.js';

import { GenericModal } from 'com-gyf-webcore-userinterfacecomponents';
import { GenericErrorScreen } from 'com-gyf-webcore-userinterfacecomponents';

import CustomModal from "./CustomModal.jsx";
import VistaModificacionEstado from './VistaModificacionEstado.jsx';

class PanelSeleccion extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: undefined,
        }

        this._dispatchToken = undefined;
    }

    componentDidMount() {
        //const id = this.props.match.params.id;
        this.props.getScreenData(this.props.vistaCliente.userFeatures);
    }

    componentWillUnmount() {
        this.props.resetState();
    }

    render() {

        let props = this.props;

        const {
            data,
            changeInput,
            changeCheck,
            changeDate,
            changeDataError,
            selectCombo,
            filtroRubro,
            changeRubro,
            cancelar,
            guardarNovedad,
            guardarNovedades,
            realizarBajaCuentaTarjeta,
            estadoEdicion,
            mostrarComponente,
            changeText,
            changeEditView,
            guardarCampo,
            actualizarNovedadEstado,
            actualizarNovedadEstados,
            saldosResumenes,
            ingresoAjustes,
            ingresoCobranzas,
            vistaCliente,
            mostrarModal,
            openModalBajaCuenta,
            closeModalBajaCuenta,
            valorTextArea,
            bloquearTarjeta,
            guardarNovedadBloqueo,
            getDiasVigencia,
            getEmpresaData,
            getCuentaData,
            getTarjetaData,
            getSaldosResumenesData,
            getIngresoAjustesData,
            getIngresoCobranzasData,
            redirectVistaCliente,
            valorSelect,
            changeCheckSolicitarCaidaCuotas,
            executionContext
        } = this.props;

        const {
            entidadTipo,
            empresaDatos,
            cuentaDatos,
            tituloCampo,
            novedadesHistoria,
            estaVisibleModalNovedad,
            mostrarSaldosResumenes,
            loading
        } = data;


        if (entidadTipo == undefined)
            return null;

        let body = undefined;
    
        switch (entidadTipo) {

            case 0:
                if (empresaDatos != undefined) {
                    body = <Empresa
                        data={data}
                        changeInput={changeInput}
                        changeCheck={changeCheck}
                        changeDate={changeDate}
                        changeDataError={changeDataError}
                        selectCombo={selectCombo}
                        filtroRubro={filtroRubro}
                        changeRubro={changeRubro}
                        cancelar={cancelar}
                        guardarNovedad={guardarNovedad}
                        guardarNovedades={guardarNovedades}
                        estadoEdicion={estadoEdicion}
                        mostrarComponente={mostrarComponente}
                        changeText={changeText}
                        changeEditView={changeEditView}
                        guardarCampo={guardarCampo}
                        mostrarModal={mostrarModal}
                        actualizarNovedadEstado={actualizarNovedadEstado}
                        actualizarNovedadEstados={actualizarNovedadEstados}
                    />
                }
                break;

            case 1:
                if (mostrarSaldosResumenes) {
                    body = <SaldosResumenes
                        data={data}
                        saldosResumenes={saldosResumenes}
                        vistaCliente={vistaCliente}
                        mostrarModal={mostrarModal}
                        mostrarComponente={mostrarComponente}
                    />
                }
                else {
                    if (cuentaDatos != undefined) {
                        body = <Cuenta
                            data={data}
                            executionContext={executionContext}
                            changeInput={changeInput}
                            changeCheck={changeCheck}
                            changeDate={changeDate}
                            changeDataError={changeDataError}
                            selectCombo={selectCombo}
                            cancelar={cancelar}
                            guardarNovedad={guardarNovedad}
                            guardarNovedades={guardarNovedades}
                            guardarCampo={props.guardarCampo}
                            realizarBajaCuentaTarjeta={realizarBajaCuentaTarjeta}
                            estadoEdicion={estadoEdicion}
                            mostrarComponente={mostrarComponente}
                            changeText={changeText}
                            changeEditView={changeEditView}
                            mostrarModal={mostrarModal}
                            actualizarNovedadEstado={actualizarNovedadEstado}
                            actualizarNovedadEstados={actualizarNovedadEstados}
                            openModalBajaCuenta={openModalBajaCuenta}
                            closeModalBajaCuenta={closeModalBajaCuenta}
                            valorTextArea={valorTextArea}
                            valorSelect={valorSelect}
                            changeCheckSolicitarCaidaCuotas={changeCheckSolicitarCaidaCuotas}
                        />
                    }
                }
                break;

            case 2: {
                body =
                    <Tarjeta
                        data={data}
                        estadoEdicion={estadoEdicion}
                        changeInput={changeInput}
                        guardarNovedad={guardarNovedad}
                        bloquearTarjeta={bloquearTarjeta}
                        selectCombo={selectCombo}
                        guardarNovedadBloqueo={guardarNovedadBloqueo}
                        cancelar={cancelar}
                        changeCheck={changeCheck}
                        guardarNovedad={guardarNovedad}
                        mostrarModal={mostrarModal}
                        actualizarNovedadEstado={actualizarNovedadEstado}
                        getDiasVigencia={getDiasVigencia}
                    />
                break;
            }

            //case 3: {
            //    body = <IngresoAjustes
            //        data={data}
            //        ingresoAjustes={ingresoAjustes}
            //        vistaCliente={vistaCliente}
            //        mostrarModal={mostrarModal}
            //        mostrarComponente={mostrarComponente}
            //        />
            //    break;
            //}

            case 4: {
                body = <IngresoCobranzas
                    data={data}
                    ingresoCobranzas={ingresoCobranzas}
                    vistaCliente={vistaCliente}
                    mostrarModal={mostrarModal}
                    mostrarComponente={mostrarComponente}
                />
                break;
            }

            default:
                body = null;
                break;
        }

        return (
            <div className="container-fluid row">

                {loading == true && <div className="loading">Loading &#8230;</div>}

                <div className="col-xs-3">
                    <MenuDesplegable
                        data={data}
                        getEmpresaData={getEmpresaData}
                        getCuentaData={getCuentaData}
                        getTarjetaData={getTarjetaData}
                        getSaldosResumenesData={getSaldosResumenesData}
                        getIngresoAjustesData={getIngresoAjustesData}
                        getIngresoCobranzasData={getIngresoCobranzasData}
                        redirectVistaCliente={redirectVistaCliente}
                    />
                </div>

                <div className="col-xs-9 left-separator separator-light">
                    {body}
                </div>

                {estaVisibleModalNovedad &&
                    <CustomModal
                        titulo={`Modificaciones de ${tituloCampo}`}
                        mostrarModal={mostrarModal}
                    >
                        <VistaModificacionEstado data={novedadesHistoria} />
                    </CustomModal>
                }
            </div>
        );

    }
}

export default PanelSeleccion;